//
import React, { useState, useEffect } from 'react';
import { StyleSheet, View, Text, Alert } from 'react-native';
import { TextInput, IconButton } from 'react-native-paper';
import Button from '../Generic/Button';
import Title from '../Generic/Title';
import Divider from '../Generic/Divider';
import cupomApi from '../../apis/cupomApi';
import { useAlert } from '../../redux/alert/alertHooks';
import { useSessao } from '../../redux/sessao/sessaoHooks';
import { useDadosPedido, usePedido } from '../../redux/pedido/pedidoHooks';
import colors from '../../colors';
import { TIPO_DESCONTO_PORCENTAGEM } from '../../shared/constants';
import {
  formatarDinheiro,
  calcularTotalDesconto,
  calcularTotalPedidoSemDesconto
} from '../../shared/helper';
import { useEmpresa } from '../../redux/empresa/empresaHooks';
import CTextInput from '../Generic/CTextInput';

type Props = {};

const InputCupom: React.FC<Props> = (props) => {
  // const [pedido] = usePedido();
  const [sessao] = useSessao();
  const [codigoCupom, setCodigoCupom] = useState('');
  const [mostrarAlert] = useAlert();
  const [setEnderecoPedido, setObservacaoPedido, setCupomPedido] = useDadosPedido();
  const [pedido] = usePedido();
  const [empresa] = useEmpresa();
  const [minimoCupomAtingido, setMinimoCupomAtingido] = useState(true);
  const [totalDesconto, setTotalDesconto] = useState(0);

  const verificarCupom = async () => {
    try {
      const cupom = await cupomApi.verificarCupom(codigoCupom);
      setCupomPedido(cupom);
    } catch (err) {
      mostrarAlert('Erro', err.data ?? 'Erro desconhecido');
    }
  };

  useEffect(() => {
    if (pedido.cupom) {
      const total = calcularTotalPedidoSemDesconto(pedido, empresa.precoDelivery);
      if (total < pedido.cupom.valorMinimoPedido) {
        setMinimoCupomAtingido(false);
      } else {
        setMinimoCupomAtingido(true);
      }
      const desconto = calcularTotalDesconto(pedido, empresa.precoDelivery);
      setTotalDesconto(desconto);
    } else {
      setTotalDesconto(0);
    }
  }, [pedido.cupom]);

  if (!sessao.token) {
    return null;
  }

  if (pedido.cupom) {
    return (
      <View>
        <Divider style={{ marginBottom: 10, marginTop: 15 }} />

        <Title style={{ marginBottom: 10 }}>Cupom Aplicado</Title>

        <View style={styles.card}>
          {!minimoCupomAtingido && (
            <Text style={styles.typoInfo}>
              MÍNIMO DO CUPOM NÃO ATINGIDO (R${formatarDinheiro(pedido.cupom.valorMinimoPedido)})
            </Text>
          )}

          <View style={styles.cardContent}>
            <Text>{pedido.cupom.codigo}</Text>

            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <Text style={styles.typoInfo}>
                {pedido.cupom.tipo === TIPO_DESCONTO_PORCENTAGEM
                  ? `${pedido.cupom.valor}% (R$${formatarDinheiro(totalDesconto)})`
                  : `R$${formatarDinheiro(pedido.cupom.valor)}`}
              </Text>

              <IconButton
                icon="close"
                color={colors.black}
                size={20}
                onPress={() => setCupomPedido(null)}
              />
            </View>
          </View>
        </View>
      </View>
    );
  }

  return (
    <View>
      <Divider style={{ marginBottom: 10, marginTop: 15 }} />

      <Title style={{ marginBottom: 10 }}>Tem cupom?</Title>
      <CTextInput
        onChangeText={(txt) => setCodigoCupom(txt)}
        value={codigoCupom}
        // style={styles.input}
        autoCapitalize={'characters'}
      />
      <Button onPress={verificarCupom} title={'APLICAR'} style={{ marginTop: 10 }} />
    </View>
  );
};

const styles = StyleSheet.create({
  typoInfo: {
    padding: 3,
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: 5,
    color: '#fff',
    backgroundColor: colors.red,
    fontSize: 11,
    fontWeight: 'bold',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  viewInfo: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  card: {
    backgroundColor: colors.veryLightGrey,
    borderRadius: 7,
    padding: 5
  },
  cardContent: {
    paddingLeft: 10,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
});

export default InputCupom;
